import { Button, Table, Tag, Tooltip } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { useState } from 'react';
import CustomButton from 'components/custom-button';
import { API } from 'service/api-route';
import { WAIVE_MODE_LABEL, labelOf } from 'pages/star-shared/labels';
import { PenaltyType } from 'pages/star-shared/types';
import { TABLE_EMPTY } from 'pages/star-shared/utils';
import { usePagedList } from 'pages/star-shared/use-paged-list';
import StarAmount from 'pages/star-shared/components/star-amount';
import { Ellipsis } from 'pages/star-shared/components/status-tags';
import PenaltyTypeModal from './penalty-type-modal';

const TypesTab = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [createOpen, setCreateOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<PenaltyType | null>(null);
  const { items, loading } = usePagedList<PenaltyType>(API.starsPenaltyTypes, {}, { refreshKey });
  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  const columns: ColumnsType<PenaltyType> = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: 'Tên loại phạt', dataIndex: 'name', key: 'name', render: (v) => <strong>{v}</strong> },
    { title: 'Mô tả', key: 'description', render: (_, t) => <Ellipsis value={t.description} width={300} /> },
    {
      title: 'Sao để xoá',
      key: 'starCost',
      width: 110,
      align: 'right',
      render: (_, t) => <StarAmount value={t.starCost} />,
    },
    {
      title: 'Cách xoá phạt',
      key: 'waiveMode',
      width: 150,
      render: (_, t) => (
        <Tag color={t.waiveMode === 'REVIEW' ? 'gold' : 'blue'}>{labelOf(WAIVE_MODE_LABEL, t.waiveMode)}</Tag>
      ),
    },
    {
      title: 'Trạng thái',
      key: 'active',
      width: 110,
      render: (_, t) => (
        <Tag color={t.active ? 'green' : 'default'} style={{ borderRadius: 6 }}>
          {t.active ? 'Đang dùng' : 'Đã tắt'}
        </Tag>
      ),
    },
    { title: 'Thứ tự', dataIndex: 'sort', key: 'sort', width: 80, align: 'right', render: (v) => v ?? 0 },
    {
      title: 'Thao tác',
      key: 'actions',
      fixed: 'right' as const,
      width: 80,
      render: (_, t) => (
        <Tooltip title="Sửa">
          <Button type="text" icon={<EditOutlined />} onClick={() => setEditTarget(t)} />
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <CustomButton bgColor="secondary-green" text="Thêm loại phạt" icon={<PlusOutlined />} onClick={() => setCreateOpen(true)} />
      </div>
      <div className="custom-table">
        <Table columns={columns} rowKey="id" pagination={false} dataSource={items} loading={loading} locale={TABLE_EMPTY} scroll={{ x: 900 }} />
      </div>
      <PenaltyTypeModal open={createOpen} penaltyType={null} onClose={() => setCreateOpen(false)} onSuccess={triggerRefresh} />
      <PenaltyTypeModal open={!!editTarget} penaltyType={editTarget} onClose={() => setEditTarget(null)} onSuccess={triggerRefresh} />
    </div>
  );
};

export default TypesTab;
